import type { ValuationKeys } from '../Entities/Valuation.entity';

export const valuationKeys: ValuationKeys = {
  uk: 'hc_vehicle_valuation_uk',
  fr: 'hc_vehicle_valuation_fr',
  de: 'hc_vehicle_valuation_de',
};
